export default "__VITE_ASSET__CBhgSPmp__"